import { useEffect, useState } from "react";

export default function Countdown({ target, className = "", compact = false }) {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!target) return null;
  const diff = new Date(target).getTime() - now;
  const expired = diff <= 0;
  const urgent = diff > 0 && diff < 48 * 3600 * 1000;

  const d = Math.max(0, Math.floor(diff / 86400000));
  const h = Math.max(0, Math.floor((diff % 86400000) / 3600000));
  const m = Math.max(0, Math.floor((diff % 3600000) / 60000));
  const s = Math.max(0, Math.floor((diff % 60000) / 1000));

  if (expired) {
    return (
      <span className={`num font-semibold text-destructive ${className}`} data-testid="countdown-expired">
        Expired
      </span>
    );
  }

  const Unit = ({ v, l }) => (
    <span className="inline-flex flex-col items-center">
      <span className="num tabular-nums leading-none">{String(v).padStart(2, "0")}</span>
      {!compact && <span className="text-[9px] uppercase tracking-widest opacity-50 mt-1">{l}</span>}
    </span>
  );

  return (
    <span
      className={`inline-flex items-center gap-2 ${urgent ? "pulse-live text-destructive" : ""} ${className}`}
      data-testid="countdown-timer"
    >
      <Unit v={d} l="days" />
      <span className="opacity-30">:</span>
      <Unit v={h} l="hrs" />
      <span className="opacity-30">:</span>
      <Unit v={m} l="min" />
      {compact ? null : (
        <>
          <span className="opacity-30">:</span>
          <Unit v={s} l="sec" />
        </>
      )}
    </span>
  );
}
